import TmpStore from '@/view/weappTmp/core/lib/base/store.js'
import { getRandwords } from '@/utils'
import { importAll } from '@/utils'
import { CompsNode } from '@/view/weappTmp/core/lib/package/comps-node.js'

// 注册基座
export function registerPedestal (arg = { name: '', notCompList: [] }) {
  const defaultArg = {
    type: 'tmps', //类型
    title: 'BaseTitle', //标题
    name: 'WeappTmp', //组件分类
    homeConfig: false, //是否开启全局配置
    notCompList: [],  //屏蔽组件
    customConfigList:[],  //全局配置项
  }
  const id = getRandwords()
  const pedestalId = `Pedestal_${arg.name}_${id}`
  console.log('registerPedestal-pedestalId',pedestalId)

  TmpStore.init(pedestalId)

  arg = Object.assign(defaultArg, arg)
  if(arg.homeConfig){    
    TmpStore.setVal('customConfigMap',{})    
    console.log('注册基座:arg2',arg)
  }
  TmpStore.setVal(pedestalId, {
    pedestalId,
    ...arg
  })
  
  console.log('registerPedestal:TmpStore:init', TmpStore)
  return pedestalId
}

// 基座注册 组件能力
export function registerComponents (path) {
  // console.log('基座注册:registerComponents1',require)
  // console.log('基座注册:registerComponents2',require.context)
  // console.log('基座注册:registerComponents',require.context(path, true, /\.vue$/))
  const TmpsProps = {}
  importAll(require.context(path, true, /\.vue$/), (key, r) => {
    console.log('')
    const keyPath = key.match(/\.\/(.+)\.vue$/)[1]
    if (keyPath.includes('props')) {
      TmpsProps[keyPath] = r(key).default ? r(key).default : r(key)
    }
  })

  const Tmps = {}
  importAll(require.context(path, true, /\.vue$/), (key, r) => {
    const keyPath = key.match(/\.\/(.+)\.vue$/)[1]
    if (keyPath.includes('index')) {
      Tmps[keyPath] = r(key).default ? r(key).default : r(key)
    }
  })

  const TmpsConfig = {}
  importAll(require.context(path, true, /\.js$/), (key, r) => {
    const keyPath = key.match(/\.\/(.+)\.js$/)[1]
    if (!['config'].includes(keyPath)) {
      TmpsConfig[keyPath] = r(key).default ? r(key).default : r(key)
      TmpsConfig[keyPath] = TmpsConfig[keyPath].config
      !TmpsConfig[keyPath] && delete TmpsConfig[keyPath]
    }
  })

  const components = {
    TmpsProps,
    Tmps,
    TmpsConfig
  }
  return components
}
// 注册 最小元素组件；
export function registerItemComps (path) {
  const comps = {}
  importAll(require.context(path, true, /\.vue$/), (key, r) => {
    const keyPath = key.match(/\.\/(.+)\.vue$/)[1]
    if (keyPath.includes('index')) {
      let keyP = keyPath.split('/')[0]
      comps[keyP] = r(key).default ? r(key).default : r(key)
    }
  })
  return comps
}
